<template>
  <div class="create-avr-modal">
    <div class="create-avr-modal__body">
      <div class="create-avr-modal__info">
        <q-icon name="info" color="blue-6" size="20px" />
        <span>
          На основании КС2В <strong>№{{ document.floor_map_document_id }}</strong>
          будет создан <strong>АВР</strong>.
        </span>
      </div>

      <div class="create-avr-modal__details">
        <div class="create-avr-modal__detail-row">
          <span class="create-avr-modal__detail-label">Проект:</span>
          <span>{{ projectDisplayLabel }}</span>
        </div>
        <div class="create-avr-modal__detail-row">
          <span class="create-avr-modal__detail-label">Контрагент:</span>
          <span>{{ document.contractor_name || '—' }}</span>
        </div>
        <div v-if="document.avr_sum" class="create-avr-modal__detail-row">
          <span class="create-avr-modal__detail-label">Сумма КС2В:</span>
          <span>{{ formatSum(document.avr_sum) }}</span>
        </div>
      </div>
    </div>

    <div class="create-avr-modal__footer">
      <q-btn flat label="Отмена" @click="$emit('close')" />
      <q-btn
        color="primary"
        label="Создать АВР"
        unelevated
        :loading="creating"
        :disable="creating"
        @click="create"
      />
    </div>
  </div>
</template>

<script>
import { createFollowupFromK2sv } from "@/views/ClosingDocuments/services";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";

export default {
  name: "CreateAvrFromK2svModal",

  props: {
    document: {
      type: Object,
      required: true,
    },
  },

  emits: ["created", "close"],

  computed: {
    /** Как в таблице закрывающих: ЖК — resident_name; «Нет названия» из project_name не показываем. */
    projectDisplayLabel() {
      const d = this.document;
      if (!d) return "—";
      const parts = [];
      if (d.resident_name) parts.push(String(d.resident_name).trim());
      const pn = d.project_name != null ? String(d.project_name).trim() : "";
      if (pn && pn !== "Нет названия") parts.push(pn);
      if (parts.length) return parts.join(" · ");
      return "—";
    },
  },

  data() {
    return {
      creating: false,
    };
  },

  methods: {
    formatSum(val) {
      if (!val) return "—";
      const n = parseFloat(val);
      if (!Number.isFinite(n)) return "—";
      return n.toLocaleString("ru-RU", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + " тг";
    },

    async create() {
      this.creating = true;
      try {
        await createFollowupFromK2sv(this.document.floor_map_document_id);
        this.showSucceedSnackbar("АВР успешно создан");
        this.$emit("created");
        this.$emit("close");
      } catch (e) {
        this.showErrorSnackbar(e?.response?.data?.message || e?.message || "Ошибка при создании АВР");
      } finally {
        this.creating = false;
      }
    },
  },

  setup() {
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar, showErrorSnackbar };
  },
};
</script>

<style lang="scss" scoped>
.create-avr-modal {
  min-width: 480px;
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 0;

  &__body {
    padding: 4px 0 20px;
  }

  &__info {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 15px;
    line-height: 1.5;
    margin-bottom: 20px;
  }

  &__details {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 14px 16px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
  }

  &__detail-row {
    display: flex;
    gap: 8px;
    font-size: 13px;
  }

  &__detail-label {
    color: #64748b;
    min-width: 100px;
    flex-shrink: 0;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;
  }
}
</style>
